import { path } from "ramda";

const defaultTexts = {
  reviewsListTitle: "Отзывы о товаре",
  reviewsEmpty: "Отзывов пока нет. Будьте первым!",
  reviewsLoading: "Загружаем отзывы...",
  reivewsSorting: {
    date: "Сначала новые",
    withPohoto: "Сначала с фото",
    useful: "Сначала полезные",
    hightGrade: "Сначала с высокой оценкой",
    lowGrade: "Сначала с низкой оценкой",
  },
  pagination: {
    loading: "Загрузка...",
    showMore: "Показать еще",
  },
  reviewsSuccess: "Спасибо! Ваш отзыв отправлен на модерацию.",
  reviewFormTitle: "Поделитесь вашим мнением",
  reviewFormFields: {
    ratingLabel: "Общая оценка *",
    reviewLabel: "Отзыв",
    photosLabel: "Выберите до 6 фото",
    firstnameLabel: "Имя *",
    lastnameLabel: "Фамилия",
    phoneLabel: "Телефон *",
    emailLabel: "E-mail *",
    emailHint: "Ваш e-mail не будет отображаться в списке отзывов",
    phoneHint: "Ваш телефон не будет отображаться в списке отзывов",
  },
  reviewFormSubmitButtonLabel: "Отправить",
  reviewFormSubmitButtonLoading: "Отправляем...",
  reviewsCollapsedListTitle: "Отзывы",
  reviewsCollapsedListAction: "Читать отзывы",
  reviewShowMore: "Показать еще",
  reviewHideMore: "Скрыть",
  reviewIsUseful: "Вам помог этот отзыв?",
  shopAnswer: "Ответ магазина",
};

/**
 * Text customization function
 *
 * getCustomText('a.b') ==> 'custom'
 * @param {string} t
 * @return {string}
 */
export function getCustomText(t) {
  return (
    path(t.split("."), {
      // @ts-ignore
      ...(window.__CC_CustomTexts__ || {}),
    }) ||
    path(t.split("."), {
      ...defaultTexts,
    }) ||
    ""
  );
}
